export default __webpack_public_path__ + "static/media/racingCurrentlyAvailable.37bf11ed.png";